import { render, staticRenderFns } from "./desktop_app_overlay.vue?vue&type=template&id=39b3c562&scoped=true&"
import script from "./desktop_app_overlay.vue?vue&type=script&lang=js&"
export * from "./desktop_app_overlay.vue?vue&type=script&lang=js&"
import style0 from "./desktop_app_overlay.vue?vue&type=style&index=0&id=39b3c562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3c562",
  null
  
)

export default component.exports